import { toast } from "sonner";

/**
 * Lightweight confirm using sonner — works in iframes where window.confirm is blocked.
 * Returns a promise resolving to true if user clicks "Supprimer", false on cancel/timeout.
 *
 * Usage:
 *   const ok = await confirmAction("Supprimer cette dépense ?");
 *   if (!ok) return;
 *   await api.delete(...)
 */
export function confirmAction(message, { confirmLabel = "Supprimer", cancelLabel = "Annuler", duration = 8000 } = {}) {
  return new Promise((resolve) => {
    let resolved = false;
    const id = toast(message, {
      duration,
      action: {
        label: confirmLabel,
        onClick: () => { resolved = true; resolve(true); toast.dismiss(id); },
      },
      cancel: {
        label: cancelLabel,
        onClick: () => { resolved = true; resolve(false); toast.dismiss(id); },
      },
      onDismiss: () => { if (!resolved) resolve(false); },
      onAutoClose: () => { if (!resolved) resolve(false); },
    });
  });
}
